import { EXTERNAL_PRODUCT_ORDER_TYPE } from '../constants';

import { buildOrderLineTotals } from './buildOrderLineTotals';

/**
 * Ordered lines (BDC) of an order past the draft status, with the totals its table displays. They
 * already come sorted by product name, and the BDL lines an order carries from `En préparation`
 * onwards are left out — they are a table of their own.
 *
 * Everything is computed from the price and the VAT rate frozen on the line at validation: a catalog
 * price changed since is deliberately ignored.
 *
 * @param {Array<Object>} products - The product orders of the order
 *
 * @returns {Array<Object>} The ordered lines, each with its total with and without taxes
 */
export const buildOrderProductLines = (products) =>
  (products ?? [])
    .filter(({ type }) => type === EXTERNAL_PRODUCT_ORDER_TYPE.TO_PREPARE)
    .map((product) => ({
      ...product,
      ...buildOrderLineTotals(product),
    }));
